//utils/paths.js
export const HOMEPAGE = "/";
export const SIGNUPPAGE = "/auth/signup";
export const LOGINPAGE = "/auth/login";
export const JOBPOSTFORM = "/jobpostform"
export const CLIENTDASHBOARD = "/clientdashboard/about"
